import React from 'react';

function ClubMatchSettings({ COLS, club, compTypes, deleteTemplate, displayVal, getSettingValue, isAllClubs, isReadOnly, isRelevant, revertToPreset, updateCompType }) {
  return (
    <div className="w3-card w3-round w3-white w3-margin-bottom">
      <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px' }}>
        <span style={{ fontWeight: 700 }}><i className="fa fa-trophy w3-margin-right"></i>Competition Types &amp; Defaults</span>
      </div>
      <div className="w3-container w3-padding">
        <p className="w3-small w3-text-grey" style={{ margin: '0 0 8px' }}>
          {isReadOnly
            ? <>This club uses the site-wide defaults managed under <b>All Clubs</b>. To change these settings, switch to All Clubs in the footer selector.</>
            : <>Edit any setting directly. {!isAllClubs && <>Customized rows are saved as club templates — <button className="w3-text-blue" style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: 'inherit' }} onClick={() => {}}>blue icons</button> indicate customized types.</>}</>}
        </p>
        <div style={{ overflowX: 'auto' }}>
          <table className="w3-table w3-bordered w3-small" style={{ minWidth: '800px' }}>
            <thead>
              <tr className="w3-theme-l4">
                <th style={{ position: 'sticky', left: 0, background: 'inherit', zIndex: 2, minWidth: '170px' }}>Competition Type</th>
                {COLS.map(c => (
                  <th key={c.key} style={{ whiteSpace: 'nowrap', textAlign: 'center', fontSize: 'var(--gs-text-sm)', position: 'relative' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: c.tip ? 'help' : 'default' }} title={c.tip || undefined}>
                      <i className={`fa ${c.icon}`} style={{ opacity: 0.6 }}></i>{c.label}{c.tip && <i className="fa fa-info-circle" style={{ fontSize: 'var(--gs-text-xs)', opacity: 0.4 }}></i>}
                    </span>
                  </th>
                ))}
                <th style={{ width: '40px' }}></th>
              </tr>
            </thead>
            <tbody>
              {compTypes.map(ct => {
                // Only club-level forks (not system overrides) count as "customized"
                const isCustomized = !isAllClubs && ct.isFork;
                const isClubCustomTemplate = !isAllClubs && ct.isTemplate && !ct.isSystemTemplate;
                const bgColor = (isCustomized || isClubCustomTemplate) ? '#e3f2fd' : '#fff';
                return (
                  <tr key={ct.key} style={{ background: bgColor }}>
                    <td style={{ position: 'sticky', left: 0, background: bgColor, zIndex: 1, whiteSpace: 'nowrap' }}>
                      <i className={`fa ${ct.icon} w3-margin-right ${(isCustomized || isClubCustomTemplate) ? 'w3-text-blue' : 'w3-text-grey'}`}></i>
                      {ct.label}
                      {isClubCustomTemplate && <span className="w3-tiny w3-text-grey w3-margin-left">(custom)</span>}
                      {isCustomized && <span className="w3-tiny w3-text-blue w3-margin-left">(customized)</span>}
                    </td>
                    {COLS.map(col => {
                      const val = getSettingValue(ct.settings, col.key);
                      const relevant = isRelevant(col, ct.settings);
                      if (!relevant) return <td key={col.key} style={{ textAlign: 'center', color: '#ccc' }}>—</td>;

                      if (isReadOnly) {
                        return <td key={col.key} style={{ textAlign: 'center' }}>{displayVal(col, val)}</td>;
                      }
                      if (col.type === 'select') {
                        return (
                          <td key={col.key} style={{ textAlign: 'center' }}>
                            <select className="w3-select w3-border w3-round" value={val ?? ''}
                              style={{ padding: '2px 4px', fontSize: 'var(--gs-text-sm)', minWidth: 0 }}
                              onChange={e => updateCompType(ct, col.key, e.target.value)}>
                              {col.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          </td>
                        );
                      }
                      if (col.type === 'text') {
                        return (
                          <td key={col.key} style={{ textAlign: 'center' }}>
                            <input className="w3-input w3-border w3-round" value={val ?? ''}
                              style={{ padding: '2px 4px', fontSize: 'var(--gs-text-sm)', minWidth: '150px' }}
                              onChange={e => updateCompType(ct, col.key, e.target.value)} />
                          </td>
                        );
                      }
                      if (col.type === 'bool') {
                        return (
                          <td key={col.key} style={{ textAlign: 'center' }}>
                            <input type="checkbox" className="w3-check" checked={!!val}
                              onChange={e => updateCompType(ct, col.key, e.target.checked)} />
                          </td>
                        );
                      }
                      return (
                        <td key={col.key} style={{ textAlign: 'center' }}>
                          <input type="number" className="w3-input w3-border w3-round" value={val ?? ''}
                            style={{ padding: '2px 4px', fontSize: 'var(--gs-text-sm)', width: '55px', textAlign: 'center', margin: '0 auto' }}
                            onChange={e => updateCompType(ct, col.key, parseInt(e.target.value) || 0)} />
                        </td>
                      );
                    })}
                    <td>
                      {!isAllClubs && ct.isFork && (
                        <button className="w3-button w3-tiny w3-round w3-text-grey w3-hover-red" onClick={() => revertToPreset(ct)} title="Revert to default">
                          <i className="fa fa-undo"></i>
                        </button>
                      )}
                      {isClubCustomTemplate && (
                        <button className="w3-button w3-tiny w3-round w3-text-red w3-hover-red" onClick={() => deleteTemplate(ct.templateId)} title="Delete template">
                          <i className="fa fa-trash"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ClubMatchSettings;
